exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".boost-buffet-or-party-event__tag {\n  position: relative;\n  color: #fff;\n  padding: 8px;\n  background: #1890ff;\n}\n.boost-buffet-or-party-event__tag.boost-buffet-or-party-event__tag--buffet {\n  background: #f9a825;\n}\n.boost-buffet-or-party-event__tag.boost-buffet-or-party-event__tag--tournament {\n  background: #fa541c;\n}\n.boost-buffet-or-party-event__info {\n  padding: 0 0 0 8px;\n}\n", ""]);

// exports
